import type { CSSProperties } from 'react'
import React from 'react'
import styles from './SvgIcon.module.css'

interface ISvgIcon {
  children: React.ReactNode
  titleAccess?: string
  viewBox?: string
  size?: number
  width?: number
  height?: number
  className?: string
}

const SvgIcon = (props: ISvgIcon) => {
  const {
    children,
    titleAccess,
    viewBox = '0 0 24 24',
    size,
    width,
    height,
    className,
    ...other
  } = props

  const svgWidth = width ?? size ?? 24
  const svgHeight = height ?? size ?? 24

  const style = {
    '--svg-width': `${svgWidth}px`,
    '--svg-height': `${svgHeight}px`,
  } as CSSProperties

  return (
    <svg
      className={`${styles.svg} ${className || ''}`}
      data-size={size}
      style={style}
      focusable="false"
      viewBox={viewBox}
      aria-hidden={titleAccess ? 'false' : 'true'}
      role={titleAccess ? 'img' : 'presentation'}
      {...other}
    >
      {children}
      {titleAccess ? <title>{titleAccess}</title> : null}
    </svg>
  )
}

export default SvgIcon
